<template>
  <v-app>
    <core-app-bar v-model="expandOnHover" class="d-print-none" />

    <core-app-drawer :expand-on-hover.sync="expandOnHover" class="d-print-none" />

    <core-app-view />

    <vue-snotify></vue-snotify>
  </v-app>
</template>

<script>
  import CoreAppBar from "./components/core/AppBar.vue";
  import CoreAppDrawer from "./components/core/Drawer.vue";
  import CoreAppView from "./components/core/View.vue";

  export default {
    name: "CoreLayout",
    components: {
      CoreAppBar,
      CoreAppDrawer,
      CoreAppView
    },
    data: () => ({
      expandOnHover: false
    })
  }
</script>